(function (analytics) {
    "use strict";

    analytics.plugins = analytics.plugins || [];

    analytics.plugins.push(function () {
        /**
         * looks for the webinar events object on the page and sets the evars and events
         * @param trackingObject
         */
        var bodyElement = document.body;

        if (typeof(bodyElement) != "undefined") {

            if (bodyElement.classList.contains("webinar-signup-confirmation")) {

                analytics.sitecatalyst.eVar54 = "Webinar";
                console.log("nadex analytics: eVar54 webinar, event85 set");
                s.events = "event85";

            } else {
                console.log("nadex analytics: this is not the webinar confirmation page");
            }
        }

        if ( document.querySelector('#webinar-title') !== null ) {
            var webinarTitleElem = document.querySelector('#webinar-title');
            s.prop75 = webinarTitleElem.getAttribute("data-topic");
            s.eVar113 = webinarTitleElem.getAttribute("data-series");
            s.prop44 = webinarTitleElem.getAttribute("data-presenter");
        }

    });


})(window.nadex.marketing.analytics);
